var map = {
	"./Barcelona_Casal_bau_close_conjunto_png.png": 5959,
	"./Barcelona_Casal_bau_open_conjunto_png.png": 7089,
	"./Barcelona_casal_scene_conjunto.png": 7280,
	"./Black_tie_Casal_bau_close_conjunto.png": 1284,
	"./Black_tie_Casal_bau_open_conjunto.png": 9208,
	"./Maranello_Casal_bau_close_conjunto_png.png": 3993,
	"./Maranello_Casal_bau_open_conjunto_png.png": 2899,
	"./Maranello_Casal_scene_conjunto.png": 398,
	"./black_tie_queen_scene_bau_open_conjunto.jpg": 9927,
	"./paris_cinza__suede_cinza_Casal_sembau_scene.png": 1621,
	"./paris_cinza_suede_cinza_Casal_conjunto_almofada.png": 4166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3432;